import { BaseFirestoreRepository } from '@core/base-firestore.repository';
import { FIRESTORE_COLLECTIONS } from '@core/constants/collections.constants';
import { UserModel } from '@modules/administration/pages/users/user.model';

export class UserRepository extends BaseFirestoreRepository<UserModel> {
  constructor() {
    super(FIRESTORE_COLLECTIONS.USERS);
  }
}
